import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardCard from "./DashboardCard";
import { DASH } from "../dashboardTheme";

export default function InventoryAlerts({ items, loading }) {
  const navigate = useNavigate();
  const hasAlerts = items.length > 0;

  return (
    <DashboardCard
      title="Inventario"
      subtitle={
        loading
          ? "Cargando..."
          : hasAlerts
            ? `${items.length} ítems bajo stock mínimo`
            : "Niveles normales"
      }
      action={
        !loading && (
          <button
            type="button"
            onClick={() => navigate("/inventario")}
            style={{
              background: "none",
              border: "none",
              fontFamily: DASH.font,
              fontSize: "11px",
              fontWeight: 500,
              color: DASH.textSecondary,
              cursor: "pointer",
              padding: "2px 0",
              letterSpacing: "0.02em",
              textDecoration: "underline",
              textUnderlineOffset: 3,
            }}
          >
            Ver inventario
          </button>
        )
      }
      sx={{ height: "100%" }}
    >
      {loading ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {[1, 2, 3, 4].map((i) => (
            <Box key={i} className="dash-skeleton" sx={{ height: 40 }} />
          ))}
        </Box>
      ) : !hasAlerts ? (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <Typography sx={{ fontSize: "13px", fontWeight: 500, color: DASH.text, mb: 0.5 }}>
            Sin alertas de stock
          </Typography>
          <Typography sx={{ fontSize: "12px", color: DASH.textMuted }}>
            Todos los ítems están en niveles adecuados
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {items.map((item, i) => {
            const pct = item.minStock > 0 ? Math.round((item.quantity / item.minStock) * 100) : 0;
            const critical = pct < 50;

            return (
              <Box
                key={item.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  py: 1.25,
                  borderBottom: i < items.length - 1 ? `1px solid ${DASH.borderLight}` : "none",
                }}
              >
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: DASH.text,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.name}
                  </Typography>
                  <Typography sx={{ fontSize: "11px", color: DASH.textMuted, mt: 0.25 }}>
                    {item.location}
                    {item.sku ? ` · ${item.sku}` : ""}
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                  <Typography
                    sx={{
                      fontFamily: DASH.fontMono,
                      fontSize: "12px",
                      fontWeight: 500,
                      color: critical ? "#9b4d4d" : DASH.text,
                    }}
                  >
                    {item.quantity}/{item.minStock}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", color: DASH.textMuted }}>
                    −{item.deficit} {item.unit}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      )}
    </DashboardCard>
  );
}
